export const deprecate = (method: string) =>
  console.error(`${method} is deprecated`)
